<template>
  <div class="detailWrap" :style="{touchAction: showCover? 'none' :'auto'}">
		<div class="load" v-show="isLoading">
			<div class="loadingHead" :style="{width: (width + 30) + 'px', height: width + 'px'}">
				<div><span></span>加载中...</div>
			</div>
		</div>
		<div class="allContent" v-show="isLoading == false">
			<div class="head">
<!--				<canvas id="dashboard" :style="{width: dashboardWidth + 'px', height: dashboardHeight + 'px', margin: '0 auto', display: 'flex'}"></canvas>-->
<!--				<div id="totalText" :style="{top: width * 0.65 + 'px'}">-->
<!--					<span :style="{backgroundImage: 'url(' + totalIcon + ')'}"></span>-->
<!--					{{totalText}}-->
<!--				</div>-->
        <div class="headContent userinfo">
          <img class="headimg" :src="userinfo.head" @error="function(event) {let img = event.srcElement;img.src = errorHeadImg; img.onerror = null;}" alt="">
          <b>{{userinfo.nickname}}</b>
          <span>“我刚刚在创客云商体验了AI智能测肤，非常有趣，也很有帮助，你也关注公众号试试看吧! 长按图片识别二维码即可关注~”</span>
          <div class="img">
            <img v-lazy="userinfo.qrcode" alt="">
            <img class="logo" src="/static/wx/img/20190110171301.png" alt="">
          </div>
        </div>
				<div class="headContent">
          <b>测肤报告</b>
          <div class="score flex-ac">
            <div class="scorebg flex-s">总分<b>{{shareScore}}</b></div>
            <div class="headBoard">
              <div v-for="item in items" :key="item.name">
                <div>{{item.name}}</div>
                <span>{{item.attr}}</span>
              </div>
            </div>
          </div>
          <div class="bgPink">
            <canvas id="spider" :style="{width: spiderWidth + 'px', height: spiderHeight + 'px', margin: '0 auto 10px', display: 'flex'}"></canvas>
            <div class="headTip">
              <!--            <span class="iconChange"></span>-->
              <!--            <span></span>-->
              *小贴士：单项分数代表严重指数
            </div>
          </div>
					<div class='partLine'>肌肤分析结果</div>
					<div class="textarea">{{words}}</div>
				</div>
			</div>
			<!-- <div class="myImage">
				<div class="imageTitle flex">
					<span></span>
					<div>我的形象</div>
				</div>
				<div class="flex-js">
					<div class="flex-sub margin-xs" v-for="item in image_items" :key="item.name">
						<p>{{item.name}}</p>
						<div>{{item.attr}}</div>
					</div>
				</div>
				<div v-if="filename_atriums && filename_eyes" class="">
					<div class="classify-scroll">
						<div class="classify-cell ">
							<img :src="isHfive?filename_atriums+'_9x9.jpg':filename_atriums" @click="previewImage(filename_atriums)" />
							<div class="scale">
								<div>上中下庭比例</div>
								<div class="radio">{{atriums_radio}}</div>
								<span></span>
								<div class="star">1:1-1.2:1 (明星比例)</div>
							</div>
						</div>
						<div class="classify-cell ">
							<img mode="aspectFill" :src="isHfive?filename_eyes+'_9x9.jpg':filename_eyes" @click="previewImage(filename_eyes)" />
							<div class="scale">
								<div>五眼比例</div>
								<div class="radio">{{eyes_radio}}</div>
								<span></span>
								<div class="star">0.8:1:1.2:1:0.8 (明星比例)</div>
							</div>
						</div>
					</div>
				</div>
			</div> -->
<!--			<div class="content" style="margin-top: 0" v-show="lists1 && lists1.length>0">-->
<!--				<div class="solveHead">-->
<!--					<span></span>-->
<!--					<div>急需解决</div>-->
<!--				</div>-->
<!--				<div class="solve">-->
<!--					<div class="resultItem" v-for="(item, index) in lists1" :key="index">-->
<!--						<div class="itemTitle">-->
<!--							<div class="flex-ac">-->
<!--								<p>{{item.name}}</p>-->
<!--								<p>{{item.result}}</p>-->
<!--							</div>-->
<!--							<span class="iconChange" @click="itemShow(index, 1)">?</span>-->
<!--							<div class="toast" v-if="item.show">{{item.what}}</div>-->
<!--						</div>-->

<!--						&lt;!&ndash; <div v-if="item.defeat_rank" class="defeatRank">-->
<!--							结果比<span>{{item.defeat_rank}}%</span>的人好-->
<!--						</div> &ndash;&gt;-->
<!--						<div class="itemResult" v-if="item.itemResult">-->
<!--							<div v-for="i in item.itemResult" :key="i.name" :style="{width: 'calc(' + 100/item.itemResult.length + '%)'}">-->
<!--								<div>{{i.result}}</div>-->
<!--								<span>{{i.name}}</span>-->
<!--							</div>-->
<!--						</div>-->
<!--						<div class="color" v-if="item.color">-->
<!--							<div :class="{'chooseColor': item.color == '透白'}"><span style='background: #f9e5d9;'></span>-->
<!--								<div>透白</div>-->
<!--							</div>-->
<!--							<div :class="{'chooseColor': item.color == '白皙'}"><span style='background: #f2d5c3;'></span>-->
<!--								<div>白皙</div>-->
<!--							</div>-->
<!--							<div :class="{'chooseColor': item.color == '自然'}"><span style='background: #efc2a7;'></span>-->
<!--								<div>自然</div>-->
<!--							</div>-->
<!--							<div :class="{'chooseColor': item.color == '小麦'}"><span style='background: #c19b88;'></span>-->
<!--								<div>小麦</div>-->
<!--							</div>-->
<!--							<div :class="{'chooseColor': item.color == '暗沉'}"><span style='background: #99715f;'></span>-->
<!--								<div>暗沉</div>-->
<!--							</div>-->
<!--							<div :class="{'chooseColor': item.color == '黝黑'}"><span style='background: #684a42;'></span>-->
<!--								<div>黝黑</div>-->
<!--							</div>-->
<!--						</div>-->
<!--						<div class="darkCircle" v-if="item.darkCircle" v-show="item.darkCircle != '无'">-->
<!--							<div :class="{'chooseDark': item.darkCircle.indexOf('色素型') !=-1 }">色素型</div>-->
<!--							<div :class="{'chooseDark': item.darkCircle.indexOf('血管型') !=-1 }">血管型</div>-->
<!--							<div :class="{'chooseDark': item.darkCircle.indexOf('阴影型') !=-1 }">阴影型</div>-->
<!--						</div>-->
<!--						<div class="filename" v-if="item.filename">-->
<!--							<div class="legend" v-if="item.name == '斑点'">-->
<!--								<div><span class="iconChange" style="background: rgb(71, 64, 165);"></span>痣</div>-->
<!--								<div><span class="iconChange" style="background: #FFE57F;"></span>雀斑</div>-->
<!--								<div><span class="iconChange" style="background: #FF4081;"></span>黄褐斑</div>-->
<!--								<div><span class="iconChange" style="background: #18FFFF;"></span>其他斑</div>-->
<!--							</div>-->
<!--							<div class="legend" v-else-if="item.name == '痘痘'">-->
<!--								<div><span class="iconChange" style="background: #E040FB;"></span>痘痘</div>-->
<!--								<div><span class="iconChange" style="background: #7C4DFF;"></span>痘印</div>-->
<!--							</div>-->
<!--							<div class="legend" v-else-if="item.name == '皱纹'">-->
<!--								<div><span class="iconChange" style="background: #FF5252;"></span>抬头纹</div>-->
<!--								<div><span class="iconChange" style="background: #FFD740;"></span>眉间纹</div>-->
<!--								<div><span class="iconChange" style="background: #64FFDA;"></span>眼周纹</div>-->
<!--								<div><span class="iconChange" style="background: #FF6E40;"></span>鱼尾纹</div>-->
<!--								<div><span class="iconChange" style="background: #536DFE;"></span>法令纹</div>-->
<!--							</div>-->
<!--							<div class="image" @click="previewImage(item.filename)">-->
<!--								<div class="loading"></div>-->
<!--								<div class="realImage" :style="{backgroundImage: 'url(' + item.filename + '_30x30.jpg)'}"></div>-->
<!--							</div>-->
<!--						</div>-->
<!--						<div class="charts" v-if="item.charts">-->
<!--							<div class="line title" :class="{skinType: item.name === '肤质'}">-->
<!--								<span class='name'></span>-->
<!--								<div>-->
<!--									<span class='none'></span>-->
<!--									<span v-for="i in item.chartsTitle" :key="i">{{i}}</span>-->
<!--								</div>-->
<!--							</div>-->
<!--							<div class="line rule" :class="{skinType: item.name === '肤质'}">-->
<!--								<span class='name'></span>-->
<!--								<div>-->
<!--									<span class='none'></span>-->
<!--									<span><span class="iconChange"></span></span>-->
<!--									<span><span class="iconChange"></span></span>-->
<!--									<span><span class="iconChange"></span></span>-->
<!--								</div>-->
<!--							</div>-->
<!--							<div class="line" v-for="i in item.charts" :class="{skinType: item.name === '肤质'}" :key="i.name">-->
<!--								<span class='name' v-if="i.name.length < 4">{{i.name}}</span>-->
<!--								<span class='name' v-else><span class="iconChange">{{i.name}}</span></span>-->
<!--								<div>-->
<!--									<span class='none'></span>-->
<!--									<span><span class="iconChange"></span></span>-->
<!--									<span><span class="iconChange"></span></span>-->
<!--									<span><span class="iconChange"></span></span>-->
<!--									<div class='column' :style="{width: 'calc(' + 100 * i.percent + '% - 7px)'}"></div>-->
<!--									<div class='point' :style="{left: 'calc(' + 100 * i.percent + '% - 1px - ' + i.percent + ' * 7px)'}"></div>-->
<!--								</div>-->
<!--							</div>-->
<!--						</div>-->
<!--						<div class="sum" v-if="item.sum">{{item.sum}}</div>-->
<!--					</div>-->
<!--				</div>-->
<!--			</div>-->
<!--			<div class="content" v-show="lists2 && lists2.length>0">-->
<!--				<div class="solveHead improveHead">-->
<!--					<span></span>-->
<!--					<div>有待提高</div>-->
<!--				</div>-->
<!--				<div class="improve">-->
<!--					<div class="resultItem" v-for="(item, index) in lists2" :key="index">-->
<!--						<div class="itemTitle">-->
<!--							<div class="flex-ac">-->
<!--								<p>{{item.name}}</p>-->
<!--								<p class="result">{{item.result}}</p>-->
<!--							</div>-->
<!--							<span class="iconChange" @click="itemShow(index, 2)">?</span>-->
<!--							<div class="toast" v-if="item.show">{{item.what}}</div>-->
<!--						</div>-->
<!--						&lt;!&ndash; <div v-if="item.defeat_rank" class="defeatRank">-->
<!--							结果比<span>{{item.defeat_rank}}%</span>的人好-->
<!--						</div> &ndash;&gt;-->
<!--						<div class="itemResult" v-if="item.itemResult">-->
<!--							<div v-for="i in item.itemResult" :style="{width: 'calc(' + 100/item.itemResult.length + '%)'}" :key="i.name">-->
<!--								<div>{{i.result}}</div>-->
<!--								<span>{{i.name}}</span>-->
<!--							</div>-->
<!--						</div>-->
<!--						<div class="color" v-if="item.color">-->
<!--							<div :class="{'chooseColor': item.color == '透白'}"><span style='background: #f9e5d9;'></span>-->
<!--								<div>透白</div>-->
<!--							</div>-->
<!--							<div :class="{'chooseColor': item.color == '白皙'}"><span style='background: #f2d5c3;'></span>-->
<!--								<div>白皙</div>-->
<!--							</div>-->
<!--							<div :class="{'chooseColor': item.color == '自然'}"><span style='background: #efc2a7;'></span>-->
<!--								<div>自然</div>-->
<!--							</div>-->
<!--							<div :class="{'chooseColor': item.color == '小麦'}"><span style='background: #c19b88;'></span>-->
<!--								<div>小麦</div>-->
<!--							</div>-->
<!--							<div :class="{'chooseColor': item.color == '暗沉'}"><span style='background: #99715f;'></span>-->
<!--								<div>暗沉</div>-->
<!--							</div>-->
<!--							<div :class="{'chooseColor': item.color == '黝黑'}"><span style='background: #684a42;'></span>-->
<!--								<div>黝黑</div>-->
<!--							</div>-->
<!--						</div>-->
<!--						<div class="darkCircle" v-if="item.darkCircle">-->
<!--							<div :class="{'chooseDark': item.darkCircle == '色素型'}">色素型</div>-->
<!--							<div :class="{'chooseDark': item.darkCircle == '血管型'}">血管型</div>-->
<!--							<div :class="{'chooseDark': item.darkCircle == '阴影型'}">阴影型</div>-->
<!--						</div>-->
<!--						<div class="filename" v-if="item.filename">-->
<!--							<div class="legend" v-if="item.name == '斑点'">-->
<!--								<div><span class="iconChange" style="background: rgb(71, 64, 165);"></span>痣</div>-->
<!--								<div><span class="iconChange" style="background: #FFE57F;"></span>雀斑</div>-->
<!--								<div><span class="iconChange" style="background: #FF4081;"></span>黄褐斑</div>-->
<!--								<div><span class="iconChange" style="background: #18FFFF;"></span>其他斑</div>-->
<!--							</div>-->
<!--							<div class="legend" v-else-if="item.name == '痘痘'">-->
<!--								<div><span class="iconChange" style="background: #E040FB;"></span>痘痘</div>-->
<!--								<div><span class="iconChange" style="background: #7C4DFF;"></span>痘印</div>-->
<!--							</div>-->
<!--							<div class="legend" v-else-if="item.name == '皱纹'">-->
<!--								<div><span class="iconChange" style="background: #FF5252;"></span>抬头纹</div>-->
<!--								<div><span class="iconChange" style="background: #FFD740;"></span>眉间纹</div>-->
<!--								<div><span class="iconChange" style="background: #64FFDA;"></span>眼周纹</div>-->
<!--								<div><span class="iconChange" style="background: #FF6E40;"></span>鱼尾纹</div>-->
<!--								<div><span class="iconChange" style="background: #536DFE;"></span>法令纹</div>-->
<!--							</div>-->
<!--							<div class="image" @click="previewImage(item.filename)">-->
<!--								<div class="loading"></div>-->
<!--								<div class="realImage" :style="{backgroundImage: 'url(' + item.filename + '_30x30.jpg)'}"></div>-->
<!--							</div>-->
<!--						</div>-->
<!--						<div class="charts" v-if="item.charts">-->
<!--							<div class="line title" :class="{skinType: item.name === '肤质'}">-->
<!--								<span class='name'></span>-->
<!--								<div>-->
<!--									<span class='none'></span>-->
<!--									<span v-for="i in item.chartsTitle" :key="i">{{i}}</span>-->
<!--								</div>-->
<!--							</div>-->
<!--							<div class="line rule" :class="{skinType: item.name === '肤质'}">-->
<!--								<span class='name'></span>-->
<!--								<div>-->
<!--									<span class='none'></span>-->
<!--									<span><span class="iconChange"></span></span>-->
<!--									<span><span class="iconChange"></span></span>-->
<!--									<span><span class="iconChange"></span></span>-->
<!--								</div>-->
<!--							</div>-->
<!--							<div class="line" v-for="i in item.charts" :class="{skinType: item.name === '肤质'}" :key="i.name">-->
<!--								<span class='name' v-if="i.name.length < 4">{{i.name}}</span>-->
<!--								<span class='name' v-else><span class="iconChange">{{i.name}}</span></span>-->
<!--								<div>-->
<!--									<span class='none'></span>-->
<!--									<span><span class="iconChange"></span></span>-->
<!--									<span><span class="iconChange"></span></span>-->
<!--									<span><span class="iconChange"></span></span>-->
<!--									<div class='column' :style="{width: 'calc(' + 100 * i.percent + '% - 7px)'}"></div>-->
<!--									<div class='point' :style="{left: 'calc(' + 100 * i.percent + '% - 1px - ' + i.percent + ' * 7px)'}"></div>-->
<!--								</div>-->
<!--							</div>-->
<!--						</div>-->
<!--						<div class="sum" v-if="item.sum">{{item.sum}}</div>-->
<!--					</div>-->
<!--				</div>-->
<!--			</div>-->
<!--			<div class="content" v-show="lists3 && lists3.length>0">-->
<!--				<div class="solveHead keepHead">-->
<!--					<span></span>-->
<!--					<div>注意保养</div>-->
<!--				</div>-->
<!--				<div class="keep">-->
<!--					<div class="resultItem" v-for="(item, index) in lists3" :key="index">-->
<!--						<div class="itemTitle">-->
<!--							<div class="flex-ac">-->
<!--								<p>{{item.name}}</p>-->
<!--								<p class="result">{{item.result}}</p>-->
<!--							</div>-->
<!--							<span class="iconChange" @click="itemShow(index, 3)">?</span>-->
<!--							<div class="toast" v-if="item.show">{{item.what}}</div>-->
<!--						</div>-->
<!--						&lt;!&ndash; <div v-if="item.defeat_rank" class="defeatRank">-->
<!--							结果比<span>{{item.defeat_rank}}%</span>的人好-->
<!--						</div> &ndash;&gt;-->
<!--						<div class="itemResult" v-if="item.itemResult">-->
<!--							<div v-for="i in item.itemResult" :style="{width: 'calc(' + 100/item.itemResult.length + '%)'}" :key="i.name">-->
<!--								<div>{{i.result}}</div>-->
<!--								<span>{{i.name}}</span>-->
<!--							</div>-->
<!--						</div>-->
<!--						<div class="color" v-if="item.color">-->
<!--							<div :class="{'chooseColor': item.color == '透白'}"><span style='background: #f9e5d9;'></span>-->
<!--								<div>透白</div>-->
<!--							</div>-->
<!--							<div :class="{'chooseColor': item.color == '白皙'}"><span style='background: #f2d5c3;'></span>-->
<!--								<div>白皙</div>-->
<!--							</div>-->
<!--							<div :class="{'chooseColor': item.color == '自然'}"><span style='background: #efc2a7;'></span>-->
<!--								<div>自然</div>-->
<!--							</div>-->
<!--							<div :class="{'chooseColor': item.color == '小麦'}"><span style='background: #c19b88;'></span>-->
<!--								<div>小麦</div>-->
<!--							</div>-->
<!--							<div :class="{'chooseColor': item.color == '暗沉'}"><span style='background: #99715f;'></span>-->
<!--								<div>暗沉</div>-->
<!--							</div>-->
<!--							<div :class="{'chooseColor': item.color == '黝黑'}"><span style='background: #684a42;'></span>-->
<!--								<div>黝黑</div>-->
<!--							</div>-->
<!--						</div>-->
<!--						<div class="darkCircle" v-if="item.darkCircle">-->
<!--							<div :class="{'chooseDark': item.darkCircle == '色素型'}">色素型</div>-->
<!--							<div :class="{'chooseDark': item.darkCircle == '血管型'}">血管型</div>-->
<!--							<div :class="{'chooseDark': item.darkCircle == '阴影型'}">阴影型</div>-->
<!--						</div>-->
<!--						<div class="filename" v-if="item.filename">-->
<!--							<div class="legend" v-if="item.name == '斑点'">-->
<!--								<div><span class="iconChange" style="background: rgb(71, 64, 165);"></span>痣</div>-->
<!--								<div><span class="iconChange" style="background: #FFE57F;"></span>雀斑</div>-->
<!--								<div><span class="iconChange" style="background: #FF4081;"></span>黄褐斑</div>-->
<!--								<div><span class="iconChange" style="background: #18FFFF;"></span>其他斑</div>-->
<!--							</div>-->
<!--							<div class="legend" v-else-if="item.name == '痘痘'">-->
<!--								<div><span class="iconChange" style="background: #E040FB;"></span>痘痘</div>-->
<!--								<div><span class="iconChange" style="background: #7C4DFF;"></span>痘印</div>-->
<!--							</div>-->
<!--							<div class="legend" v-else-if="item.name == '皱纹'">-->
<!--								<div><span class="iconChange" style="background: #FF5252;"></span>抬头纹</div>-->
<!--								<div><span class="iconChange" style="background: #FFD740;"></span>眉间纹</div>-->
<!--								<div><span class="iconChange" style="background: #64FFDA;"></span>眼周纹</div>-->
<!--								<div><span class="iconChange" style="background: #FF6E40;"></span>鱼尾纹</div>-->
<!--								<div><span class="iconChange" style="background: #536DFE;"></span>法令纹</div>-->
<!--							</div>-->
<!--							<div class="image" @click="previewImage(item.filename)">-->
<!--								<div class="loading"></div>-->
<!--								<div class="realImage" :style="{backgroundImage: 'url(' + item.filename + '_30x30.jpg)'}"></div>-->
<!--							</div>-->
<!--						</div>-->
<!--						<div class="charts" v-if="item.charts">-->
<!--							<div class="line title" :class="{skinType: item.name === '肤质'}">-->
<!--								<span class='name'></span>-->
<!--								<div>-->
<!--									<span class='none'></span>-->
<!--									<span v-for="i in item.chartsTitle" :key="i">{{i}}</span>-->
<!--								</div>-->
<!--							</div>-->
<!--							<div class="line rule" :class="{skinType: item.name === '肤质'}">-->
<!--								<span class='name'></span>-->
<!--								<div>-->
<!--									<span class='none'></span>-->
<!--									<span><span class="iconChange"></span></span>-->
<!--									<span><span class="iconChange"></span></span>-->
<!--									<span><span class="iconChange"></span></span>-->
<!--								</div>-->
<!--							</div>-->
<!--							<div class="line" v-for="i in item.charts" :class="{skinType: item.name === '肤质'}" :key="i.name">-->
<!--								<span class='name' v-if="i.name.length < 4">{{i.name}}</span>-->
<!--								<span class='name' v-else><span class="iconChange">{{i.name}}</span></span>-->
<!--								<div>-->
<!--									<span class='none'></span>-->
<!--									<span><span class="iconChange"></span></span>-->
<!--									<span><span class="iconChange"></span></span>-->
<!--									<span><span class="iconChange"></span></span>-->
<!--									<div class='column' :style="{width: 'calc(' + 100 * i.percent + '% - 7px)'}"></div>-->
<!--									<div class='point' :style="{left: 'calc(' + 100 * i.percent + '% - 1px - ' + i.percent + ' * 7px)'}"></div>-->
<!--								</div>-->
<!--							</div>-->
<!--						</div>-->
<!--						<div class="sum" v-if="item.sum">{{item.sum}}</div>-->
<!--					</div>-->
<!--				</div>-->
<!--			</div>-->
<!--      <div class="head" style="background: transparent">-->
<!--        <div class="headContent userinfo qrcodeBox">-->
<!--          <div class="img">-->
<!--            <img v-lazy="userinfo.qrcode" alt="">-->
<!--            <img class="logo" src="/static/wx/img/20190110171301.png" alt="">-->
<!--          </div>-->
<!--          <span>长按图片，识别二维码测肤</span>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="footer">-->
<!--        <b><img src="/static/wx/img/20190110171301.png" alt="">创客云商商城APP</b>-->
<!--        <p>让人们轻松触达科技带来的美好</p>-->
<!--      </div>-->
			<canvas v-show="false" id="canvas" :style="{width: shareWidth + 'px', height: shareHeight + 'px'}"> </canvas>
<!--			<div class="myImage" v-if="source && isWx != 5">-->
<!--				<div class="imageTitle flex">-->
<!--					<div class="goBtn" @click="goQuestion">下一步</div>-->
<!--					&lt;!&ndash; <div class="goBtn" @click="goRecommend">下一步</div> &ndash;&gt;-->
<!--				</div>-->
<!--			</div>-->
		</div>
<!--		<div class="rightMenu" v-if="isWx != 5 && orgtype != 'juzi'">-->
<!--			<div class="commonBtn" @click="goskinTest">再测一次</div>-->
<!--			<div class="commonBtn" @click="homeClick">回首页</div>-->
<!--		</div>-->
	</div>
</template>

<script>
import { ImagePreview } from 'vant';
import { isWx, basepath, getQueryString, parametersCombine, isWeixin, fenxiang, isApp, Base64 } from '../../assets/common/js/config'
import wx from 'weixin-js-sdk'
export default {
	data() {
		return {
			width: '',
			height: '',
			spiderWidth: '',
			spiderHeight: '',
			dashboardWidth: '',
			dashboardHeight: '',
			shareWidth: '',
			shareHeight: '',
			words: '',
			chooseIndex: 0,
			navTop: 1,
			top: 0,
			showCover: false,
			shareImage: basepath + 'static/images/skinAnalysis/loading.gif',
			shareUrl: '',
			color: '',
			totalIcon: basepath + 'static/images/skinAnalysis/face1.png',
			totalText: '皮肤急需修复',
			items: [],
			image_items: [],
			lists: [{
				name: '皱纹',
				result: '68分',
				what: '如果是比较严重的皱纹，治疗方式多以剌激胶原蛋白增生或使肌肉放松等机制着手，针对不同种类皱纹的有不同的治疗方式。',
				show: false,
				itemResult: [{
					name: '条数',
					result: '78'
				}, {
					name: '条数',
					result: '78'
				}],
				darkCircle: ['血管型', '色素型'],
				color: '白皙',
				filename: '#',
				chartsTitle: ['轻度', '中度', '重度'],
				charts: [{
					name: '抬头纹',
					percent: 0.8
				}, {
					name: '法令纹',
					percent: 0.5
				}, {
					name: '法令纹',
					percent: 0
				}],
				sum: '如果是比较严重的皱纹，治疗方式多以剌激胶原蛋白增生或使肌肉放松等机制着手，针对不同种类皱纹的有不同的治疗方式。',
				url: '#',
				urlName: '立即改善内白积分',
				ads: [{
					img: this.basepath + 'static/images/skinAnalysis/guanbimeiyan.png',
					km: 0.3,
					title: '这是一段测试文字这是一段测试文字',
					price: '34',
					oldPrice: '89'
				}, {
					img: this.basepath + 'static/images/skinAnalysis/guanbimeiyan.png',
					km: 0.5,
					title: '这是一段测试文字这是一段测试文字',
					price: '34',
					oldPrice: '89'
				}]
			}],
			lists1: [],
			lists2: [],
			lists3: [],
			shareScore: '',
			shareTag: '',
			version: 1,
			isLoading: true,
			style: 1,
			yiyuan: false,
			sex: '',
			atriums_radio: '',
			filename_atriums: '',
			eyes_radio: '',
			filename_eyes: '',
			isHfive: true,
			filehost: 'https://api.yimei.ai',
			apihost: basepath,
			source: null,
			isWx: null,
      shareinfo: {},
      userinfo: {}
		}
	},
	created() {
		this.source = getQueryString('source') || null
		this.isWx = isWx
		this.orgtype = this.$route.query.orgtype
		console.log(window.location.href)
		console.log(this.$route.query.orgtype)
		this.share()
	},
	mounted() {
		const screenWidth = document.body.clientWidth, screenHeight = document.body.clientHeight;

		this.width = screenWidth - 30
		this.height = screenHeight
		this.spiderWidth = this.width - 50
		this.spiderHeight = this.width - 50
		this.dashboardWidth = this.with
		this.dashboardHeight = this.width
		this.isLoading = false

		this.getResult()
	},
	methods: {
    share() {
      if (isWeixin() && this.shareinfo.sharetitle) {
        var arg = isApp(), shareInfo, base = new Base64();
        shareInfo = {
          title: encodeURIComponent(this.shareinfo.sharetitle),
          desc: encodeURIComponent(this.shareinfo.sharedesc),
          type: 'analysisDetailposter',
          path: 'analysisDetail',
          dataStr: 'type=analysisDetailposter&params=' + base.encode(JSON.stringify(this.$route.query)),
          imgx: this.shareinfo.shareimg
        }
        if (arg.indexOf('xcx') >= 0) {
          shareInfo = {
            type: shareinfo.type,
            title: encodeURIComponent(shareinfo.title),
            link: basepath + this.$route.fullPath.substring(1) + arg,
            img: shareinfo.imgx
          }
          wx.miniProgram.postMessage({data: shareInfo})
        } else {
          fenxiang(shareInfo)
        }
      }
    },
		itemShow(i, witchlist) {
			if (witchlist == 1) {
				this.lists1[i].show = !this.lists1[i].show
			} else if (witchlist == 2) {
				this.lists2[i].show = !this.lists2[i].show
			} else if (witchlist == 3) {
				this.lists3[i].show = !this.lists3[i].show
			}
		},
		getText(data, ty, service) {
			let srvDefault = {
				servicename: {
					spot: '斑点',
					pore: '毛孔',
					sensitive: '敏感度',
					wrinkle: '皱纹',
					blackhead: '黑头',
					dark_circle: '黑眼圈',
					pimple: '痘痘',
					roughness: '粗糙度',
					pigment: '色素沉着',
					elasticity: '肌肤弹性'
				},
				btn_text: {
					spot: '快速祛斑淡斑',
					pore: '立即改善毛孔粗大',
					sensitive: '立即改善敏感肌',
					wrinkle: '立即淡化细纹',
					blackhead: '立即摆脱草莓鼻',
					dark_circle: '立即淡化黑眼圈',
					pimple: '立即告别痘痘肌',
					roughness: '快速打造水光肌',
					pigment: '快速淡化色素',
					elasticity: '肌肤弹性激活'
				}
			}
			let text = '默认'
			if (srvDefault[ty][service]) {
				text = srvDefault[ty][service]
			}
			if (data.suggestion && data.suggestion[ty]) {
				text = data.suggestion[ty]
			}
			return text
		},
		isRightKey(key) {
			let urlNamesDefault = [
				'spot',
				'pore',
				'sensitive',
				'wrinkle',
				'blackhead',
				'dark_circle',
				'pimple',
				'roughness',
				'pigment',
				'elasticity',
				'pockmark',
				'corneum',
				'moisture', // 水分
				// 'texture', // 纹理
				// 'chloasma' // 棕色斑

			];
			for (let ii in urlNamesDefault) {
				if (key == urlNamesDefault[ii]) {
					return true
				}
			}
			return false
		},
		getAnalysisConf(msgdata, _this) {
			let scores = []
			let srvNames = {}
			let srvNamesEN = {}
			let urlNames = {}
			let detailUrl = 'push.html'
			for (let ii in msgdata) {
				let isRight = _this.isRightKey(ii)
				if (!isRight) {
					continue
				}
				srvNamesEN[ii] = ii
				let score = parseInt(msgdata[ii].score);
				if (score > 99) {
					score = 99
				}
				if (score < 1) {
					score = 5
				}
				if (ii == 'sensitive' && msgdata[ii].score == 60) {
					// 敏感肌肤中性
					score = 88
				}
				score = score - 100
				let sname = _this.getText(msgdata[ii], 'servicename', ii)
				let bname = _this.getText(msgdata[ii], 'btn_text', ii)
				srvNames[ii] = sname;
				urlNames[ii] = bname;
				let s = {
					id: ii,
					name: sname,
					score: score,
					type: ''
				}
				if (ii === 'dark_circle') {
					let dark_circle_type = ''
					if (msgdata.dark_circle.type == 'HHX') {
						dark_circle_type = '混合型'
					} else if (msgdata.dark_circle.type == 'SSX') {
						dark_circle_type = '色素型'
					} else if (msgdata.dark_circle.type == 'XGX') {
						dark_circle_type = '血管型'
					}
					s.type = dark_circle_type
				}
				let ishas = _this.isHasItem(scores, sname)
				if (!ishas) {
					scores.push(s)
				}
			}
			return {
				detailUrl: detailUrl,
				srvNames: srvNames,
				srvNamesEN: srvNamesEN,
				urlNames: urlNames,
				scores: scores
			}
		},
		getShareData(msg, _this) {
			let tag = ''
			if (msg.score > 92) {
				let keywords = ['无暇瓷肌', '盛世美颜', '水嫩完美肌', '新生婴儿肌', '吹弹可破']
				tag = keywords[parseInt(Math.random() * keywords.length - 1)]
			} else {
				let contrast = [];
				if (msg.color) {
					if (msg.color.result == 'toubai') {
						contrast.push({
							name: 'color',
							score: 100
						})
					} else if (msg.color.result == 'baixi') {
						contrast.push({
							name: 'color',
							score: 80
						})
					}
				}
				if (msg.wrinkle) {
					contrast.push({
						name: 'wrinkle',
						score: msg.wrinkle.score
					})
				}
				if (msg.pore) {
					contrast.push({
						name: 'pore',
						score: msg.pore.score
					})
				}
				if (msg.pimple) {
					contrast.push({
						name: 'pimple',
						score: msg.pimple.score
					})
				}
				if (msg.dark_circle) {
					contrast.push({
						name: 'dark_circle',
						score: msg.dark_circle.score
					})
				}
				contrast.sort(function(a, b) {
					return b.score - a.score
				})
				let _keywords = {
					color: ['美白课代表', '白成一道光', '透白牛奶肌', '无龄雪肌', '肤白貌美', '牛奶美肌'],
					pimple: ['零痘痘星人', '痘痘终结者'],
					pore: ['剥壳鸡蛋', '细滑雪肌', '细滑婴儿肌', '反“孔”精英'],
					dark_circle: ['眼神动人', '电眼撩人'],
					wrinkle: ['绝世小可爱', '青春无敌', '紧致元气肌', '冻龄美肌', '水润嘭嘭肌']
				}
				let keyword = _keywords[contrast[0].name]
				tag = keyword[parseInt(Math.random() * keyword.length - 1)]
			}

			let shareUrl = ''
			if (_this.lists1.length > 0) {
				shareUrl = _this.lists1[0].url
			} else if (_this.lists2.length > 0) {
				shareUrl = _this.lists2[0].url
			}
			return {
				shareScore: msg.score,
				shareTag: tag,
				shareUrl: shareUrl
			}
		},
		isHasItem(items, itname) {
			for (let it in items) {
				if (items[it].name == itname) {
					return true
				}
			}
			return false
		},
		previewImage: function(image) {
			ImagePreview([image]);
		},
		getDataList(ty, scores, msg, srvNames, srvNamesEN, detailUrl, urlNames, _this) {
			let detailName = {
				glabella: '眉间纹',
				crowfeet: '鱼尾纹',
				nasolabial: '法令纹',
				eyecorner: '眼角纹',
				wforehead: '抬头纹',
				B_QTB: '其他斑',
				B_QB: '雀斑',
				B_HHB: '黄褐斑',
				Z_Z: '痣',
				NONE: '无',
				HHX: '混合型',
				SSX: '色素型',
				XGX: '血管型',
				CC_DY: '痘印',
				CC_QZNB: '痘痘',
				CC_DD: '痘痘',
				front: '前额',
				top: '头顶',
				left: '左侧',
				right: '右侧',
				back: '脑后',
				forehead: '额头',
				nose: '鼻子',
				chin: '下巴',
				eye_area: '眼周',
				cheeks: '脸颊'
			}
			let listsData = []
			let chooseIndex = 0
			let lenlimit = 3
			let start = 0
			let limitScore = -20
			let defaultText = '大家好我是默认文案建议'
			if (ty === 2) {
				lenlimit = _this.lists1.length + 3
				if (lenlimit > scores.length) {
					lenlimit = scores.length
				}
				start = _this.lists1.length
				limitScore = -10;
			} else if (ty === 3) {
				lenlimit = scores.length
				start = _this.lists1.length + _this.lists2.length
				let hasskintype = _this.isHasItem(_this.lists2, '肤质')
				if (hasskintype) {
					start--
				}
				let hascolor = _this.isHasItem(_this.lists2, '肤色')
				if (hascolor) {
					start--
				}
				limitScore = 100
			}
			for (let i = start; i < lenlimit; i++) {
				if (scores[i].score < limitScore) {
					let introduction = msg[scores[i].id].suggestion ? msg[scores[i].id].suggestion.introduction : defaultText
					let tips = msg[scores[i].id].suggestion ? msg[scores[i].id].suggestion.tips : defaultText
					let chart = []
					let chartsTitle = ['轻度', '中度', '重度']
					let list = {
						files: [],
						filesPart: [],
						name: srvNames[scores[i].id],
						nameEn: srvNamesEN[scores[i].id],
						what: introduction,
						show: false,
						chartsTitle: chartsTitle,
						sum: tips,
						url: detailUrl,
						urlName: urlNames[scores[i].id],
						// defeat_rank: _this.getDfrank(msg, scores[i].id),
						charts: [{
							name: srvNames[scores[i].id],
							percent: -scores[i].score / 100
						}]
					}

					if (_this.style === 1) {
						list.result = 100 + scores[i].score + '分'
					} else if (_this.style === 2) {
						list.result = -scores[i].score + '分'
					} else if (_this.style === 3 || _this.style === 4) {
						if (-scores[i].score < 31) {
							list.result = '轻度'
						} else if (-scores[i].score < 61) {
							list.result = '中度'
						} else {
							list.result = '重度'
						}
					}
					if (msg[scores[i].id].filename) {
						list.filename = _this.filehost + '/fileSvr/get/' + msg[scores[i].id].filename
					}
					if (msg[scores[i].id].parts) {
						chart = [];
						for (let j in msg[scores[i].id].parts) {
							let dtName = detailName[msg[scores[i].id].parts[j].cls]
							let percent = (100 - msg[scores[i].id].parts[j].score) / 100
							chart.push({
								name: dtName,
								percent: percent
							})
						}
						list.charts = chart
					}
					if (scores[i].id == 'wrinkle') {
						chart = [];
						for (let _i4 in msg.wrinkle.category) {
							let pname = detailName[msg.wrinkle.category[_i4].cls];
							if (msg.wrinkle.category[_i4].cls == 'forehead') {
								pname = detailName.wforehead;
							}
							if (msg.wrinkle.category[_i4].cls == 'nasolabial' && msg.wrinkle.category[_i4].score == 0 && msg.wrinkle.category[
									_i4].value > 0) {
								chart.push({
									name: pname,
									percent: msg.wrinkle.category[_i4].value / 2
								})
							} else {
								chart.push({
									name: pname,
									percent: (100 - msg.wrinkle.category[_i4].score) / 100
								})
							}
						}
						list.charts = chart
					}

					if (scores[i].id == 'sensitive' || scores[i].id == 'sensitivity') {
						let result = ''
						if (msg[scores[i].id].type == 'tolerance') {
							result = '耐受'
							list.charts = [{
								name: '敏感度',
								percent: 0.167
							}];
						} else if (msg[scores[i].id].type == 'normal') {
							result = '中性';
							list.charts = [{
								name: '敏感度',
								percent: 0.5
							}];
						} else {
							result = '敏感'
							list.charts = [{
								name: '敏感度',
								percent: 0.833
							}]
						}
						let ishas = _this.isHasItem(_this.items, '敏感度')
						if (!ishas) {
							_this.items.push({
								name: '敏感度',
								attr: result
							})
						}
						list.result = result
						list.chartsTitle = ['耐受', '中性', '敏感'];
					}


					if (scores[i].id == 'roughness') {
						list.chartsTitle = ['光滑', '一般', '粗糙'];
					}
					if (scores[i].id == 'spot') {
						chart = [];
						let spotName = {
							B_QTB: '其他斑',
							B_QB: '雀斑',
							B_HHB: '黄褐斑',
							Z_Z: '痣'
						};
						for (let _i55 in spotName) {
							let chartitem = null;
							for (let _i5 in msg.spot.category) {
								if (_i55 == msg.spot.category[_i5].cls) {
									chartitem = {
										name: spotName[msg.spot.category[_i5].cls],
										percent: (100 - msg.spot.category[_i5].score) / 100,
										result: msg.spot.category[_i5].count
									}
									break
								}
							}
							if (chartitem) {
								chart.push(chartitem);
							} else {
								chartitem = {
									name: spotName[_i55],
									percent: 0,
									result: 0
								}
								chart.push(chartitem)
							}
						}
						list.itemResult = chart
						list.charts = chart
					}
					if (scores[i].id == 'blackhead' || scores[i].id == 'pore') {
						list.itemResult = [{
							name: '明显' + srvNames[scores[i].id] + '数量',
							result: msg[scores[i].id].count
						}, {
							name: srvNames[scores[i].id] + '面积占比',
							result: (msg[scores[i].id].area * 100).toFixed(2) + '%'
						}];
					}

					if (scores[i].id == 'dark_circle') {
						if (msg.dark_circle.type == 'HHX') {
							list.darkCircle = ['色素型', '血管型']
						} else if (msg.dark_circle.type == 'SSX') {
							list.darkCircle = ['色素型']
						} else if (msg.dark_circle.type == 'XGX') {
							list.darkCircle = ['血管型']
						}
					}

					if (scores[i].id == 'pimple') {
						chart = [];
						let itemResult = []

						for (let _i6 in msg.pimple.scores) {
							chart.push({
								name: detailName[msg.pimple.scores[_i6].cls],
								percent: (100 - msg.pimple.scores[_i6].score) / 100
							});
							itemResult.push({
								name: '明显' + detailName[msg.pimple.scores[_i6].cls] + '数量',
								result: msg.pimple.scores[_i6].count
							});
						}
						list.itemResult = itemResult
						list.charts = chart
					}
					listsData.push(list)
				}
			}

			if (msg.skin_type && ty > 1) {
				let _chart6 = [];
				let skinType = {
					mix: '混合性',
					oil: '油性',
					dry: '干性',
					mid: '中性',
					mid_oil: '中性偏油',
					mid_dry: '中性偏干'
				};
				let skinParts = {
					left_cheek: '左脸',
					right_cheek: '右脸',
					forehead: '额头',
					nose: '鼻子',
					chin: '下巴',
					eye_area: '眼周',
					cheeks: '脸颊'
				};
				let ishas = _this.isHasItem(_this.items, '肤质')
				if (!ishas) {
					_this.items.push({
						name: '肤质',
						attr: msg.skin_type.type ? skinType[msg.skin_type.type] : msg.skin_type.score + '分'
					})
				}

				let introduction = msg.skin_type.suggestion ? msg.skin_type.suggestion.introduction : defaultText
				let tips = msg.skin_type.suggestion ? msg.skin_type.suggestion.tips : defaultText
				let skinlist = {
					name: '肤质',
					nameEn: 'skinType',
					result: msg.skin_type.type ? skinType[msg.skin_type.type] : msg.skin_type.score + '分',
					what: introduction,
					show: false,
					chartsTitle: ['偏干', '中性', '偏油'],
					charts: _chart6,
					sum: tips,
					urlName: '立即改善肤质',
					url: detailUrl,
					// defeat_rank: _this.getDfrank(msg, 'skin_type'),
					files: [],
					filesPart: []
				};
				let oilresult = msg.skin_type.category ? msg.skin_type.category : []
				for (let _i11 in oilresult) {
					let partname = skinParts[oilresult[_i11].cls]
					let percent = oilresult[_i11].score / 100;
					if (oilresult[_i11].cls === 'chin') {
						percent = (100 - oilresult[_i11].score) / 100;
					}
					_chart6.push({
						name: partname,
						percent: percent
					})
				}
				let lishas = _this.isHasItem(listsData, '肤质');
				let l2ishas = _this.isHasItem(_this.lists2, '肤质');

				let isskintype = 0
				if (msg.skin_type.score && (msg.skin_type.score - 100) < limitScore) {
					isskintype = 1
				}
				if ((msg.skin_type.type && ['干性', '油性', '混合性'].indexOf(skinType[msg.skin_type.type]) > -1)) {
					isskintype = 1
				}
				if (isskintype == 1 && ty == 2 && !lishas) {
					listsData.push(skinlist)
				}
				if (isskintype == 1 && ty == 3 && !lishas && !l2ishas) {
					listsData.push(skinlist)
				}
			}
			if (msg.color && ty > 1) {
				let allColor = {
					toubai: '透白',
					baixi: '白皙',
					ziran: '自然',
					xiaomai: '小麦',
					anchen: '暗沉',
					youhei: '黝黑'
				}
				let scoreColor = {
					toubai: 99,
					baixi: 88,
					ziran: 77,
					xiaomai: 66,
					anchen: 55,
					youhei: 44
				}
				let introduction = msg.color.suggestion ? msg.color.suggestion.introduction : defaultText
				let tips = msg.color.suggestion ? msg.color.suggestion.tips : defaultText
				let colorlist = {
					name: '肤色',
					result: allColor[msg.color.result],
					what: introduction,
					show: false,
					color: allColor[msg.color.result],
					sum: tips,
					urlName: '还原嫩白肌肤',
					url: detailUrl,
					// defeat_rank: _this.getDfrank(msg, 'color'),
					files: [],
					filesPart: []
				}
				if (msg.color.parts) {
					let colorresult = [];
					let _chart6 = [];
					colorresult = msg.color.parts
					for (let _i11 in colorresult) {
						let partname = colorresult[_i11].cls !== 'other' ? skinParts[colorresult[_i11].cls] : '0' + (parseInt(_i11) + 1)
						_chart6.push({
							name: partname,
							percent: (100 - scoreColor[colorresult[_i11].result]) / 100
						})
						if (colorresult[_i11].filename) {
							skinlist.files.push(_this.filehost + '/fileSvr/get/' + colorresult[_i11].filename)
							skinlist.filesPart.push(partname)
						}
					}
					colorlist.chartsTitle = ['偏黑', '自然', '白皙']
					colorlist.charts = _chart6
				}
				if (ty == 2 && ['toubai', 'baixi', 'ziran'].indexOf(msg.color.result) < 0 && listsData.length < 3) {
					listsData.push(colorlist)
				} else if (ty == 3 && ['toubai', 'baixi', 'ziran'].indexOf(msg.color.result) >= 0) {
					listsData.push(colorlist)
				}
			}
			if (listsData.length < 1) {
				chooseIndex = 1
			}
			return {
				listsData: listsData,
				chooseIndex: chooseIndex,
				items: _this.items
			}
		},
		getDfrank(msg, key) {
			let dfrank = (msg.defeat_rank && msg.defeat_rank[key]) ? msg.defeat_rank[key] : ''
			if (dfrank !== '') {
				dfrank = parseInt(100 * dfrank)
			}
			return dfrank
		},
		setDetailData(res, id) {
			let _this = this
			if (res.data.code == 0 && res.data.status == 2) {
				res.data.analysis.region = ''
				sessionStorage.setItem('detail_data', JSON.stringify(res))
				_this.result_id = id
				let msg = res.data.analysis
				let spider = []
				if (msg.age) {
					_this.items.push({
						name: '肤龄',
						attr: msg.age.result
					})
				}

				if (msg.color.result) {
					let allColor = {
						toubai: '透白',
						baixi: '白皙',
						ziran: '自然',
						xiaomai: '小麦',
						anchen: '暗沉',
						youhei: '黝黑'
					}
					_this.items.push({
						name: '肤色',
						attr: allColor[msg.color.result]
					})
				}
				//我的形象
				// if (msg.appearance.score) {
				// 	_this.image_items.push({
				// 		name: '颜值',
				// 		attr: msg.appearance.score + "分"
				// 	})
				// }
				// if (msg.face_shape.shape) {
				// 	let allFace = {
				// 		'tian_character': '方型脸',
				// 		'yuan_character': '圆形脸',
				// 		'tong_character': '蛋形脸',
				// 		'shen_character': '钻石脸',
				// 		'you_character': '梨形脸',
				// 		'jia_character': '瓜子脸',
				// 		'mu_character': '长形脸',
				// 		'wang_character': '老板脸',
				// 		'feng_character': '梨形脸',
				// 		'yong_character': '洋梨脸'
				// 	}
				// 	_this.image_items.push({
				// 		name: '脸型',
				// 		attr: allFace[msg.face_shape.shape]
				// 	})
				// }
				// if (msg.eye_shape.eye_type) {
				// 	let allEye = {
				// 		'upper': '丹凤眼',
				// 		'downer': '柳叶眼',
				// 		'round': '铜铃眼',
				// 		'extreme_small': '睡凤眼',
				// 		'big': '杏眼',
				// 		'small': '小鹿眼'
				// 	}

				// 	_this.image_items.push({
				// 		name: '眼型',
				// 		attr: allEye[msg.eye_shape.eye_type[0]]
				// 	})
				// }
				// if (msg.lip_shape) {
				// 	let allLip = {
				// 		'big': '明星唇',
				// 		'small': '桃花唇',
				// 		'normal': '',
				// 		'little_big': '',
				// 		'little_small': '',
				// 		'top_thin': '',
				// 		'bottom_thin': '',
				// 		'full': '性感唇',
				// 		'thin': '柳叶唇',
				// 		'little_thin': '',
				// 		'u': '',
				// 		'v': '微笑唇'
				// 	}
				// 	if (allLip[msg.lip_shape.mouth_type[0]] != '') {
				// 		_this.image_items.push({
				// 			name: '嘴型',
				// 			attr: allLip[msg.lip_shape.mouth_type[0]]
				// 		})
				// 	}
				// }

				//三庭五眼
				// if (msg.face_ratio.filename_atriums) {
				// 	if(_this.isHfive){
				// 		_this.filename_atriums = _this.filehost + '/fileSvr/get/' + msg.face_ratio.filename_atriums
				// 	}else{
				// 		_this.filename_atriums = _this.apihost + '/wxcefu/normalapi/showimage.php?orderid=' + id +
				// 			"&check_type=filename_atriums&access_token=" + localStorage.getItem('access_token')
				// 	}
				// 	_this.atriums_radio = msg.face_ratio.atriums_radio[0].toFixed(1) + ":" + msg.face_ratio.atriums_radio[1].toFixed(
				// 		1) + ":" + msg.face_ratio.atriums_radio[2].toFixed(1)
				// }
				// if (msg.face_ratio.filename_eyes) {
				// 	if(_this.isHfive){
				// 		_this.filename_eyes = _this.filehost + '/fileSvr/get/' + msg.face_ratio.filename_eyes
				// 	}else{
				// 		_this.filename_eyes = _this.apihost + '/wxcefu/normalapi/showimage.php?orderid=' + id +
				// 			"&check_type=filename_eyes&access_token=" + localStorage.getItem('access_token')
				// 	}
				// 	_this.eyes_radio = msg.face_ratio.eyes_radio[0].toFixed(1) + ":" + msg.face_ratio.eyes_radio[1].toFixed(1) + ":" +
				// 		msg.face_ratio.eyes_radio[2].toFixed(1) + ":" + msg.face_ratio.eyes_radio[3].toFixed(1) + ":" + msg.face_ratio.eyes_radio[
				// 			4].toFixed(1)
				// }

				if (msg.features) {
					let male = msg.features.male
					let female = msg.features.female
					if (male > female) {
						_this.sex = '男'
					} else {
						_this.sex = '女'
					}
				}

				let objConf = _this.getAnalysisConf(msg, _this)
				let detailUrl = objConf.detailUrl
				let srvNames = objConf.srvNames
				let srvNamesEN = objConf.srvNamesEN
				let urlNames = objConf.urlNames

				/*****************************蜘蛛图**************************/
				let tmp_scores = objConf.scores
				let scores = []
				let tmp_spider = JSON.parse(JSON.stringify(tmp_scores))
				console.log('tmp_spider', tmp_spider)
				for (let _i2 in tmp_spider) {
					scores.push(tmp_scores[_i2])
					if (tmp_spider[_i2].id === 'pigment' || tmp_spider[_i2].id === 'elasticity') {
						continue
					}
					spider.push(tmp_spider[_i2])
				}
				_this.spider = spider
				console.log('雷达图数据', spider)
				scores.sort(function(a, b) {
					return a.score - b.score
				})
				/*****************************list 急需解决,有待提高,继续保持**************************/
				//急需解决
				let listObj = _this.getDataList(1, scores, msg, srvNames, srvNamesEN, detailUrl, urlNames, _this)
				_this.lists1 = listObj.listsData
				_this.chooseIndex = listObj.chooseIndex
				_this.items = listObj.items

				//有待提高
				listObj = _this.getDataList(2, scores, msg, srvNames, srvNamesEN, detailUrl, urlNames, _this)
				_this.lists2 = listObj.listsData
				_this.chooseIndex += listObj.chooseIndex
				_this.items = listObj.items

				// 继续保持
				listObj = _this.getDataList(3, scores, msg, srvNames, srvNamesEN, detailUrl, urlNames, _this)
				_this.lists3 = listObj.listsData
				_this.items = listObj.items

				let words = ''
				let defaultIngredient = '默认文案'
				if (msg.pimple) {
					words += msg.pimple.suggestion ? msg.pimple.suggestion.ingredient : 'pimple' + defaultIngredient
				}
				if (msg.pore) {
					words += msg.pore.suggestion ? msg.pore.suggestion.ingredient : 'pore' + defaultIngredient
				}
				if (msg.spot) {
					words += msg.spot.suggestion ? msg.spot.suggestion.ingredient : 'spot' + defaultIngredient
				}

				_this.words = words
				_this.isLoading = false

				let ddscore = res.data.score
				// let ic = _this.getDashBordIcon(ddscore)
				// _this.totalText = ic.totalText
				// _this.totalIcon = ic.totalIcon
				// _this.drawDashboard(ddscore)
				_this.drawSpider(spider)
				let shareObj = _this.getShareData(msg, _this)
				_this.shareScore = shareObj.shareScore
				_this.shareTag = shareObj.shareTag
				_this.shareUrl = shareObj.shareUrl
			} else {
				_this.$toast(res.data.msg)
			}

		},
		getResult() {
			let id = getQueryString('orderid'), url;
			if (id) {
				if (this.$route.query.orgtype == 'juzi') {
					url = this.$ajax.detail_YiYuanApickys_URL+'?orderid=' + id
				} else {
					url = this.$ajax.detail_URL+'?orderid=' + id
				}

        this.$customRequestAjax(url).then((res) => {
					if (res.data.code == 0 && res.data.status == 2) {
            this.shareinfo = res.data.shareinfo ? res.data.shareinfo : {}
            this.userinfo = res.data.userinfo ? res.data.userinfo : {}
						sessionStorage.setItem('detail_data', JSON.stringify(res))
						sessionStorage.setItem('detail_id', id)
						this.setDetailData(res, id)
					} else {
						this.$toast('获取肌肤分析结果失败，请重新测试')
					}
				});
			} else {
				let id = sessionStorage.getItem('detail_id'),  res = sessionStorage.getItem('detail_data');

				if(id && res){
					res = JSON.parse(res)
					this.setDetailData(res, id)
				} else {
					this.$toast('获取肌肤分析结果失败，请重新测试')
				}
			}

		},
		getDashBordIcon(ddscore) {
			let totalIcon
			let totalText
			let path = this.apihost + 'static/images/skinAnalysis/face'
			let i = 1;
			if (ddscore > 90) {
				i = 1
				totalText = '健康肌肤'
			} else if (ddscore > 80) {
				i = 2
				totalText = '肌肤状况良好'
			} else if (ddscore > 60) {
				i = 3
				totalText = '肌肤有待提高'
			} else {
				i = 4
				totalText = '肌肤急需修复'
			}
			totalIcon = path + i + '.png'
			return {
				totalText: totalText,
				totalIcon: totalIcon
			}
		},
		changeNav(i) {
			this.eventStat('event_2', {
				'param1': 'detail.changeNav.' + i
			})
			this.chooseIndex = i
			if (this.top > this.navTop) {
				window.scrollTo(0, this.navTop)
			}
		},
		getRatio(context) {
			let devicePixelRatio, backingStoreRatio, ratio;

			devicePixelRatio = window.devicePixelRatio || 1
			backingStoreRatio = context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio ||
				context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1

			ratio = devicePixelRatio / backingStoreRatio

			return ratio
		},
		drawDashboard(score) {
			score = parseFloat(score)
			if (score > 90) {
				this.totalIcon = this.apihost + 'static/images/skinAnalysis/face1.png'
				this.totalText = '健康肌肤'
			} else if (score > 80) {
				this.totalIcon = this.apihost + 'static/images/skinAnalysis/face2.png'
				this.totalText = '肌肤状况良好'
			} else if (score > 60) {
				this.totalIcon = this.apihost + 'static/images/skinAnalysis/face3.png'
				this.totalText = '肌肤有待提高'
			} else {
				this.totalIcon = this.apihost + 'static/images/skinAnalysis/face4.png'
				this.totalText = '肌肤急需修复'
			}

			this.dashboardWidth = this.width
			this.dashboardHeight = this.width

			let width = parseInt(this.width)
			let canvas1 = document.getElementById("dashboard")
			let ctx = canvas1.getContext("2d")
			let ratio = this.getRatio(ctx)

			canvas1.width = this.dashboardWidth * ratio
			canvas1.height = this.dashboardHeight * ratio
			ctx.scale(ratio, ratio)
			// 画圆
			ctx.beginPath()
			let grad = ctx.createLinearGradient(0, 0, 0, width)
			grad.addColorStop(0, 'rgba(255,255,255,0.5)')
			grad.addColorStop(0.5, 'rgba(255,255,255,0.2)')
			grad.addColorStop(0.8, 'rgba(255,255,255,0)')
			grad.addColorStop(1, 'rgba(255,255,255,0)')
			ctx.fillStyle = grad
			ctx.arc(width / 2, width / 2, width * 0.35, 0, Math.PI * 2)
			ctx.fill()

			// 轨道
			ctx.beginPath()
			ctx.lineCap = 'round'
			ctx.strokeStyle = '#FF1C80'
			ctx.lineWidth = parseInt(width * 0.015)
			ctx.arc(width / 2, width / 2, width * 0.31, Math.PI * 0.85, Math.PI * 0.15)
			ctx.stroke()

			// 进度
			ctx.beginPath()
			ctx.lineCap = 'round'
			ctx.strokeStyle = '#FFFFFF'
			ctx.lineWidth = parseInt(width * 0.02)
			ctx.arc(width / 2, width / 2, width * 0.31, Math.PI * 0.85, Math.PI * (0.85 + 1.3 * score / 100))
			ctx.stroke()

			// 划线
			ctx.beginPath()
			ctx.lineWidth = 1
			ctx.strokeStyle = 'rgba(255,255,255,0.3)'
			ctx.arc(width / 2, width / 2, width * 0.4, Math.PI * 0.9, Math.PI * 1.13)
			ctx.stroke()
			ctx.beginPath()
			ctx.arc(width / 2, width / 2, width * 0.4, Math.PI * 1.23, Math.PI * 1.45)
			ctx.stroke()
			ctx.beginPath()
			ctx.arc(width / 2, width / 2, width * 0.4, Math.PI * 1.55, Math.PI * 1.78)
			ctx.stroke()
			ctx.beginPath()
			ctx.arc(width / 2, width / 2, width * 0.4, Math.PI * 1.88, Math.PI * 0.1)
			ctx.stroke()

			// 刻度分数等文字
			ctx.beginPath()
			ctx.font = parseInt(width * 0.03) + 'px Arial'
			ctx.fillStyle = 'rgba(255,255,255,0.7)'
			ctx.textAlign = 'center'
			ctx.fillText("0", width * 0.14, width * 0.67)
			ctx.fillText("25", width * 0.15, width * 0.3)
			ctx.fillText("50", width * 0.5, width * 0.11)
			ctx.fillText("75", width * 0.85, width * 0.3)
			ctx.fillText("100", width * 0.86, width * 0.67)
			ctx.font = parseInt(width * 0.04) + 'px Arial'
			ctx.fillText("肌肤良好指数", width * 0.5, width * 0.37)
			ctx.fillStyle = 'rgba(255,255,255,1)'
			ctx.font = parseInt(width * 0.2) + 'px Arial'
			ctx.fillText(score, width * 0.5, width * 0.55)

			// 点
			ctx.beginPath()
			ctx.lineCap = 'round'
			ctx.strokeStyle = '#ffffff'
			ctx.lineWidth = parseInt(width * 0.04)
			ctx.shadowBlur = parseInt(width * 0.01)
			ctx.shadowColor = "#999"
			ctx.arc(width / 2, width / 2, width * 0.31, Math.PI * (0.85 + 1.3 * score / 100), Math.PI * (0.85 + 1.3 * (score +
				0.02) / 100))

			setTimeout(function() { //必须延迟执行 不然H5不显示
				ctx.stroke()
				// ctx.draw() //必须加上  uniapp 没这儿玩意儿 显示不出来不比原生  不加可以显示
			}, 220)
		},
		drawSpider(obj) {
			// 高分屏兼容
			this.spiderWidth = this.width - 50
			this.spiderHeight = this.width - 50

			let l = Object.keys(obj).length
			let w = this.width - 50
			let canvas2 = document.getElementById("spider")
			let ctx = canvas2.getContext("2d")
			let ratio = this.getRatio(ctx)

			canvas2.width = this.spiderWidth * ratio
			canvas2.height = this.spiderHeight * ratio
			ctx.scale(ratio, ratio)

			// 画刻度线
			function drewLine(n) {
				ctx.beginPath()
				ctx.strokeStyle = 'rgba(255,58,128,0.3)'
				ctx.lineWidth = 1
				let angle = Math.PI * 1
				for (let i = 0; i < l; i++) {
					ctx.lineTo(0.5 * w + 0.35 * w * Math.sin(angle) * n, 0.5 * w + 0.35 * w * Math.cos(angle) * n)
					angle += Math.PI * (360 / l) / 180
				}
				ctx.closePath()
				ctx.stroke()
			}
			drewLine(1)
			drewLine(0.75)
			drewLine(0.5)
			drewLine(0.25)

			// 画辅助线
			let angle = Math.PI * 1
			for (let i = 0; i < l; i++) {
				ctx.beginPath()
				ctx.moveTo(0.5 * w, 0.5 * w)
				ctx.lineTo(0.5 * w + 0.35 * w * Math.sin(angle), 0.5 * w + 0.35 * w * Math.cos(angle))
				ctx.stroke()
				angle += Math.PI * 360 / l / 180
			}

			// 多边形
			ctx.beginPath()
			ctx.lineWidth = parseInt(w * 0.01)
			ctx.strokeStyle = 'rgb(255,58,128)'
			ctx.fillStyle = 'rgba(255,58,128,0.4)'
			angle = Math.PI * 1
			for (let i in obj) {
				ctx.lineTo(0.5 * w + 0.35 * w * Math.sin(angle) * (100 + obj[i].score) / 100, 0.5 * w + 0.35 * w * Math.cos(angle) *
					(100 + obj[i].score) / 100)
				angle -= Math.PI * 360 / l / 180
			}
			ctx.closePath()
			ctx.fill()
			ctx.stroke()

			// 描点 绘制文字
			angle = Math.PI * 1
			for (let i in obj) {
				ctx.beginPath()
				ctx.strokeStyle = 'rgb(255,255,255)'
				ctx.fillStyle = 'rgb(255,58,128)'
				ctx.lineWidth = parseInt(w * 0.01)
				ctx.shadowBlur = parseInt(w * 0.01)
				ctx.shadowColor = "rgba(255,58,128,0.5)"
				ctx.arc(0.5 * w + 0.35 * w * Math.sin(angle) * (100 + obj[i].score) / 100, 0.5 * w + 0.35 * w * Math.cos(angle) *
					(100 + obj[i].score) / 100, parseInt(w * 0.01), 0, 2 * Math.PI)
				ctx.stroke()
				ctx.fill()
				ctx.beginPath()
				ctx.font = parseInt(w * 0.04) + 'px Arial'
				ctx.fillStyle = 'rgb(255,58,128)'
				ctx.shadowBlur = 0
				ctx.textAlign = 'center'
				ctx.fillText((100 + obj[i].score) + '分', 0.5 * w + 0.35 * w * Math.sin(angle) * 1.2, 0.5 * w + 0.35 * w * Math.cos(
					angle) * 1.2 - w * 0.02)
				ctx.beginPath()
				ctx.font = parseInt(w * 0.04) + 'px Arial'
				ctx.fillStyle = 'rgb(51,51,51)'
				ctx.fillText(obj[i].name, 0.5 * w + 0.35 * w * Math.sin(angle) * 1.2, 0.5 * w + 0.35 * w * Math.cos(angle) * 1.2 +
					w * 0.03)
				angle -= Math.PI * 360 / l / 180
			}
			setTimeout(function() { //必须延迟执行 不然H5不显示
				// ctx.draw() //必须加上  uniapp 没这儿玩意儿 显示不出来不比原生  不加可以显示
				ctx.stroke()
			}, 200)
		},
		openshare() {
			if (this.shareImage == this.apihost + 'static/images/skinAnalysis/loading.gif') {
				this.drawShareImage(this.shareScore, this.shareTag)
				this.showCover = true
			} else {
				this.showCover = true
			}
		},
		drawShareImage(score, tag) {
			let shareText = [
				['变美跟努力一样，是会上瘾的，', '尤其是在尝到了甜头之后。'],
				['思想跟肌肉都要持续锻练，', '灵魂和肉体都必须性感。'],
				['这个世界上定有舞台', '为我而亮，定有人为我而来。'],
				['您要相信，您一定会是', '某个人翘首以盼的惊喜。'],
				['美丽，从您决定做自己那一刻开始。'],
				['为什么护肤品那么贵？因为您的脸值钱呀。'],
				['为什么护肤品那么贵？', '因为人们眼中的青春太贵。'],
				['亲爱的，少吃点糖，不是因为吃糖', '容易长痘，而是因为您已经够甜了。'],
				['生活苦，梦要甜，您要甜。'],
				['变美路上最大的敌人', '不是皮肤不好，而是这磨人的生活。'],
				['“可爱”不会因为年龄的增长而消失。'],
				['所谓优雅，就是您遵从内心', '活成您自己幸福快乐的样子。'],
				['出色些，从容貌到能力。'],
				['人间不值得，但小仙女您值得。'],
				['勇敢去爱，勇敢去生活。'],
				['只要您变得足够优秀，多愁善感就追不上您。'],
				['此生很长/ 您就该/ 明媚张扬。'],
				['当您越来越优秀的时候，', '就会遇见越来越好的人。'],
				['您未来的样子藏在您现在的努力里。'],
				['爱时不辜负人，玩时不辜负风景；', '睡觉时不辜负床，一个人时不辜负自己。'],
				['经历的太少，鸡毛蒜皮，都是烦恼。']
			]
			let canvas3 = document.createElement('canvas')
			let ctx = canvas3.getContext('2d')
			this.shareWidth = 335
			this.shareHeight = 508
			// 高分屏兼容
			ctx.scale(1, 1)

			// 选择文案
			let length = shareText.length
			let i = parseInt(Math.random() * length)

			// 绘制背景图
			ctx.beginPath()
			ctx.fillStyle = 'rgba(255,255,255,0)'
			ctx.fillRect(0, 0, 335, 508)

			ctx.beginPath()
			ctx.fillStyle = 'rgba(0,0,0,255)'
			ctx.font = '16px Arial'
			ctx.fillText('肌肤健康指数', 30, 50)
			ctx.fillText('分，我的美丽关键词', 150, 50)
			ctx.fillText('上测肤APP 体验AI测肤黑科技', 15, 445)
			ctx.beginPath()
			ctx.fillStyle = 'rgba(200,200,200,255)'
			ctx.font = '12px Arial'
			ctx.fillText('宜远智能提供技术支持', 103, 470)
			ctx.beginPath()
			ctx.textAlign = 'center'
			ctx.fillStyle = 'rgba(255,58,128,255)'
			ctx.font = '18px Arial'
			ctx.fillText(score, 138, 50)
			ctx.beginPath()
			ctx.font = '14px Arial'
			if (shareText[i].length == 1) {
				ctx.fillText(shareText[i][0], 167.5, 355)
			} else {
				ctx.fillText(shareText[i][0], 167.5, 345)
				ctx.fillText(shareText[i][1], 167.5, 365)
			}
			ctx.beginPath()
			ctx.font = '26px Arial blod'
			ctx.fillText(tag, 167.5, 90)
			ctx.beginPath()
			ctx.font = '20px Arial blod'
			ctx.fillText('『', 15, 340)
			ctx.fillText('』', 320, 375)

			ctx.beginPath()
			ctx.lineWidth = 1
			ctx.strokeStyle = 'rgba(216,216,216,255)'
			ctx.moveTo(0, 400)
			ctx.lineTo(335, 400)
			ctx.stroke()
			ctx.beginPath()
			ctx.moveTo(20, 467)
			ctx.lineTo(90, 467)
			ctx.stroke()

			ctx.beginPath()
			let img = new Image()
			if (score > 92) {
				img.src = this.apihost + 'static/images/skinAnalysis/share5.jpg'
			} else {
				img.src = this.apihost + 'static/images/skinAnalysis/share' + (parseInt(Math.random() * 4) + 1) + '.jpg'
			}
			img.onload = () => {
				ctx.drawImage(img, 67, 112, 200, 200)
				let qrcode = new Image()
				qrcode.src = this.apihost + 'static/images/skinAnalysis/qrcode.png'
				qrcode.onload = () => {
					ctx.drawImage(qrcode, 240, 415, 80, 80)
					let dataUrl = canvas.toDataURL("image/png")
					let name = (dataUrl.split(',')[0].match(/:(.*?);/)[1] || 'image/png').replace('/', '.')
					let fileImg = this.base64ToBlob(dataUrl)
					let post = new FormData()
					post.append('name', fileImg, name)
					post.append('app_name', 'api_app')
					this.uploadImage(post)
				}
			}
		},
		uploadImage(reqParam) {
			// const self = this
			// uni.request({
			// 	url: self.apihost + '/fileSvr/put',
			// 	data: reqParam,
			// 	header: {
			// 		'Content-Type': 'multipart/form-data'
			// 	},
			// 	success: (res) => {
			// 		if (res.data.code === '10000') {
			// 			self.shareImage = self.apihost + '/fileSvr/get/' + res.data.img_path
			// 		} else {
			// 			util.alert('分享图生成失败，请重试');
			// 		}
			// 	}
			// })
		},
		base64ToBlob(urlData) {
			var arr = urlData.split(',')
			var mime = arr[0].match(/:(.*?);/)[1] || 'image/jpg'
			// 去掉url的头，并转化为byte
			var bytes = window.atob(arr[1])
			// 处理异常,将ascii码小于0的转换为大于0
			var ab = new ArrayBuffer(bytes.length)
			// 生成视图（直接针对内存）：8位无符号整数，长度1个字节
			var ia = new Uint8Array(ab)
			for (var i = 0; i < bytes.length; i++) {
				ia[i] = bytes.charCodeAt(i)
			}
			return new Blob([ab], {
				type: mime
			})
		},
		// 跳转至问题列表
		goQuestion() {
			let query = parametersCombine(), sex = this.$route.query.sex
			query.type = 2
			if (sex) {
				sessionStorage.setItem('sex', sex)
				console.log('一样样')
			}

			this.$router.push({
				path: '/skinQuestioin',
                query: query
			})
		},
		// 跳转至推荐商品列表
		goRecommend() {
			let query = parametersCombine()
			this.$router.push({
				path: '/skinProducts',
                query: query
			})
		},
		// 跳转至测肤首页
		goskinTest() {
			let query = parametersCombine()
			this.$router.push({
				path: '/skinAnalysis',
                query: query
			})
		},
		// 跳转至商城首页
		homeClick: function () {
			var arg = isApp()
			if (arg == '') {
				window.location.href = '/'
			} else if (arg.indexOf('xcx') < 0) {
				window.ReactNativeWebView.postMessage(JSON.stringify({
				type: 'goIndex'
				}))
			} else {
				wx.miniProgram.switchTab({ url: '/pages/index/main' })
			}
		},
	}
}
</script>
<style scoped lang="scss">
	@import '../../assets/css/skinAnalysis/detail.scss';
	.rightMenu {
		z-index: 10;
		position: fixed;
		right: 0;
		top: 50%;
		transform: translateY(-50%);
		margin: 0 auto;
    	box-sizing: initial;
		.commonBtn {
			width: 0.3rem;
			padding: 0.08rem;
			background:rgba(255,255,255,1);
			border-radius: 0.08rem 0 0 0.08rem;
			box-shadow:0 0.01rem 0.05rem 0 rgba(159,159,159,0.5);
			font-size: 0.14rem;
			text-align: center;
			background:#ff3a80;
			color: #fff;
			&:nth-child(2) {
				margin-top: 0.1rem;
				background:#ff7527
			}
		}
	}
	.flex {
		display: flex;
	}
</style>
<style>
	.connect {
		font-size: 0.16rem;
		background-color: #ffffff;
		color: #999;
		text-align: center;
		width: 100%;
		height: 0.4rem;
		line-height: 0.4rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/skinAnalysis/detailposter.vue